<template>
  <div class="container-size-blog">
    <img loading="lazy" :src="blog.image_url" class="img-ctn-mobile" v-if="mobileView" />
    <div class="back-btn" @click="toBack" v-if="mobileView">
      <img src="/img/other/arrow-back.png" alt="back icon" />
    </div>
    <v-alert class="alert-info" type="success" :value="show_alert">Copied</v-alert>
    <div class="spacing" v-if="mobileView"></div>
    <div class="main-page">
      <div class="navigation" v-if="!mobileView">
        <span @click="toBlog" class="nav-active font-poppins">Home</span>
        <Arrow :width="20" direct="left" />
        <span class="font-poppins">{{ blog.title }}</span>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="text-center mt-5" v-if="!mobileView">
            <img loading="lazy" :alt="`${blog.title}`" :src="blog.image_url" class="img-main-dekstop" />
          </div>
          <div class="author">
            <div class="author-info">
              <span class="font-poppins">{{ onDateFormatting(blog.date_release) }}</span>
              <span class="circle"></span>
              <span v-if="blog.reading_minute" class="font-poppins">Dibaca {{ blog.reading_minute }} menit</span>
            </div>
          </div>
          <div class="author" v-if="mobileView">
            <img src="/img/other/ic_facebook_gray.png" alt="facebook" title="Share in facebook"
              @click="onShareFacebook" />
            <img src="/img/other/ic_linkedin_gray.png" alt="linkedin" title="Share in linkedin"
              @click="onShareLinkedin" />
            <img src="/img/other/ic_email_gray.png" alt="email" title="Share in email" @click="onShareEmail" />
            <img src="/img/other/ic_copylink_gray.png" alt="copy" title="copy url" @click="onCopyUrl" />
          </div>
          <h1 class="mt-5" style="font-size: 26px;">{{ blog.title }}</h1>
          <div class="text-justify mt-5 main-body" ref="contentContainer" v-html="blog.body"></div>
          <div class="art-content">
            <h5 class="font-poppins mb-4">
              Kamu Mungkin Juga Suka
            </h5>
            <div class="art-content-list">
              <div class="card" v-for="(item, idx) in blogs" :key="idx" @click="toArticle(item.slug_name, item.title)">
                <img class="card-img" :src="item.thumbnail_url" :alt="`${item.title}`" />
                <div class="card-content">
                  <p class="bold title-berita">
                    {{ $minimizeText(item.title, 110) }}
                  </p>
                  <span class="font-poppins">{{ onDateFormatting(item.date_release) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-right">
          <div class="content-right-scroll">
            <p>Share</p>
            <span title="Share in facebook" @click="onShareFacebook">
              <facebook />
            </span>
            <span title="Share in linkedin" @click="onShareLinkedin">
              <linkedin />
            </span>
            <img src="/img/other/ic_email_gray.png" alt="email" title="Share in email" @click="onShareEmail" />
            <span title="copy url" @click="onCopyUrl">
              <copy />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from "@/assets/icons/Arrow.vue";
import Facebook from '@/assets/icons/blog/Facebook.vue';
import Linkedin from '@/assets/icons/blog/Linkedin.vue';
import Copy from '@/assets/icons/blog/Copy.vue';

export default {
  data() {
    return {
      blog: {
        title: "",
        body: "",
        summary: ""
      },
      show_alert: false,
      mobileView: false,
      isLoading: false,
      blogs: [],
      month_list: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  components: {
    Arrow,
    Facebook,
    Copy,
    Linkedin
  },
  metaInfo() {
    return {
      title: `HiColleagues | ${this.blog.title}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.blog.meta_description}`
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `HiColleagues | ${this.blog.title}`
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: `${this.blog.meta_description}`
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: 'index, follow'
        }
      ]
    }
  },
  watch: {
    show_alert() {
      if (!this.show_alert) return;
      setTimeout(() => {
        this.show_alert = false;
      }, 3000);
    },
  },
  methods: {
    async getBlogDetail() {
      this.isLoading = true;
      try {
        const response = await this.$http.get("/v1/blog/" + this.$route.params.slugname);
        this.blog = response.data.data.blog;
        this.isLoading = false;

      } catch (err) {
        console.error(err);
        this.isLoading = false;
      }
    },
    async getBlogs() {
      try {
        const response = await this.$http.get("/v1/blog/related");
        this.blogs = response.data.data.blogs || [];
      } catch (err) {
        console.error(err.response);
      }
    },
    toBlog() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go to Blog List - Blog Detail Page',
        value: 1,
      });
      this.$router.push("/blog");
    },
    onDateFormatting(dateStr) {
      const date = new Date(dateStr);
      return `${date.getDate()} ${this.month_list[date.getMonth()]} ${date.getFullYear()}`;
    },
    onCopyUrl() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Copy URL - ${this.blog.title} - Blog Detail Page`,
        value: 1,
      });
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard;
      clipboardData.writeText(window.location.href);
      this.show_alert = true;
    },
    onShareEmail() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Share Email - ${this.blog.title} - Blog Detail Page`,
        value: 1,
      });
      let url = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${this.blog.title}&body=${window.location.href}&ui=2&tf=1&pli=1`;
      window.open(url);
    },
    onShareLinkedin() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Share LinkedIn - ${this.blog.title} - Blog Detail Page`,
        value: 1,
      });
      let url = `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}&title=${this.blog.title}`;
      window.open(url);
    },
    onShareFacebook() {
      this.$gtag.event('click', {
        event_category: 'Interaction',
        event_label: `Share Facebook - ${this.blog.title} - Blog Detail Page`,
        value: 1,
      });
      let url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
      window.open(url);
    },
    toArticle(slug, title) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Related Blog - ${title} - Blog Detail Page`,
        value: 1,
      });
      this.$router.push("/blog/" + slug);
      this.getBlogDetail();
      this.getBlogs();
      window.scrollTo(0, 0);
    },
    toBack() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Go Back - Blog Detail Page',
        value: 1,
      });
      this.$router.go(-1);
    },
    handleView() {
      if (window.innerWidth <= 990) {
        this.mobileView = true;
      }
    },
    applyStyles() {
      const container = this.$refs.contentContainer;
      if (container) {
        container.querySelectorAll('*').forEach(p => {
          p.style.fontFamily = 'Poppins, sans-serif';
        });
        container.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(heading => {
          heading.querySelectorAll('strong').forEach(strong => {
            const parent = strong.parentNode;
            while (strong.firstChild) {
              parent.insertBefore(strong.firstChild, strong);
            }
            strong.remove();
          });
        });
      }
    }
  },
  created() {
    this.getBlogDetail();
  },
  updated() {
    this.applyStyles();
  },
  mounted() {
    this.getBlogDetail();
    this.applyStyles();
    this.getBlogs();
    this.handleView();
    this.$gtag.pageview(this.$route);
  },
};
</script>

<style src="./detailBlog.css" scoped></style>